<div *ngIf="adat" class="usz-sav" [class.kieses]="kieses" role="status">
  <ion-icon [name]="kieses ? 'warning-outline' : 'time-outline'"></ion-icon>
  <div class="usz-torzs">
    <span class="usz-cim">
      {{ adat.nev }} –
      {{ kieses ? 'üzemszünet / kiesés' : (elozetes ? 'tervezett karbantartás (előre jelzett)' : 'tervezett karbantartás') }}
    </span>
    <span class="usz-uzenet" *ngIf="adat.uzenet">{{ adat.uzenet }}</span>
    <span class="usz-ido" *ngIf="idoablak">
      <ion-icon name="calendar-outline"></ion-icon>{{ elozetes ? 'Várható: ' : '' }}{{ idoablak }}
    </span>
  </div>
</div>
